// extracted by mini-css-extract-plugin
export default {"buttonStyles":"Button_buttonStyles__rWlrW"};